module.exports = __webpack_public_path__ + "static/media/kubernetes-50.4b13d31c.png";